/**
 * useExtractCustomerAddressInformation Hook
 * Extracts and formats customer address information for display
 * @see mobile: module-customer/src/modules/addresses/hooks/use-extract-customer-address-information.ts
 */

'use client';

import { useMemo } from 'react';
import type { CustomerAddress } from '../../../types';

export interface CustomerAddressInformation {
    firstname: string;
    lastname: string;
    telephone: string;
    city: string;
    district: string;
    ward: string;
    street: string[];
    id: string | number;
}

export const useExtractCustomerAddressInformation = (
    customerAddress: CustomerAddress | Partial<CustomerAddress>
): CustomerAddressInformation => {
    return useMemo(
        () => ({
            firstname: customerAddress?.firstname ?? 'N/A',
            lastname: customerAddress?.lastname ?? 'N/A',
            telephone: customerAddress?.telephone ?? 'N/A',
            city: customerAddress?.city ?? 'N/A',
            district: customerAddress?.district ?? 'N/A',
            ward: customerAddress?.ward ?? 'N/A',
            street:
                customerAddress?.street
                    ?.filter(street => street !== null)
                    ?.map(street => street?.toString() ?? 'N/A') ?? [],
            id: customerAddress?.id ?? '',
        }),
        [
            customerAddress?.city,
            customerAddress?.district,
            customerAddress?.firstname,
            customerAddress?.id,
            customerAddress?.lastname,
            customerAddress?.street,
            customerAddress?.telephone,
            customerAddress?.ward,
        ]
    );
};
